import React from "react";
import AddDocument from "./AddDocument";
export const AddDocumentIndex: React.FC = () => {

    return (
        <AddDocument/>
    )
} 